import Cookies from 'js-cookie'
export default function AccessToken() {
  let token = Cookies.get('token');
  if (token) {
    return {token: token};
  } else {
    return {token: ''};
  }
}
